import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export interface DeleteSavedSearchDialogProps {
  readonly open: boolean;
  readonly name: string;
  readonly inUseError: boolean;
  readonly onConfirm: () => void;
  readonly onClose: () => void;
}

export default function DeleteSavedSearchDialog({
  open,
  name,
  inUseError,
  onConfirm,
  onClose,
}: DeleteSavedSearchDialogProps) {
  const { t } = useTranslation(["search"]);
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t("search:savedSearch.v2.dialogDeleteTitle", { name })}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("search:savedSearch.v2.dialogDeleteBody")}
        </DialogContentText>
        {inUseError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {t("search:savedSearch.v2.dialogInUse")}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("search:savedSearch.v2.cancel")}</Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          {t("search:savedSearch.v2.confirmDelete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
